var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section map-container"},[_c('div',{ref:"mapEl"}),_c('a',{staticClass:"link",attrs:{"href":_vm.streetViewLink,"target":"_blank"}},[_vm._v(" Open in Google StreetView ")]),_c('a',{staticClass:"link",attrs:{"href":_vm.currentHref,"target":"_blank"}},[_vm._v(" Open in Perilfinder ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }